/** Human-readable byte counts for quota meters and asset cards. */
export function formatBytes(b: number): string {
  if (b >= 1024 ** 3) return `${(b / 1024 ** 3).toFixed(2)} GB`;
  if (b >= 1024 ** 2) return `${(b / 1024 ** 2).toFixed(2)} MB`;
  if (b >= 1024) return `${(b / 1024).toFixed(2)} KB`;
  return `${b} B`;
}

export const ACCEPTED_ASSET_MIMES = 'image/png,image/jpeg,image/webp';
export const MAX_ASSET_UPLOAD_BYTES = 50 * 1024 * 1024;
